import React, { useContext } from 'react';
import AppContext from '../context/Context';
import PropertiesRoutes from '../routes/PropertiesRoutes';

const PropertiesLayout = ( ) => {
    const { isFluid } = useContext(AppContext);

    return  <div className={isFluid ? 'container-fluid' : 'container'}>
                <PropertiesRoutes />
            </div>
}

export default PropertiesLayout;